const menus = [
    {
        id: 1,
        name: 'Home',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'Home 01',
                links: '/'
            },
            {
                id: 2,
                sub: 'Home 02',
                links: '/home-02'
            },
            {
                id: 3,
                sub: 'Home 03',
                links: '/home-03'
            },
            {
                id: 4,
                sub: 'Home One Page',
                links: '/home-one-page/'
            },
        ]
    },
    {
        id: 2,
        name: 'About',
        links: '/home-one-page/#about'
    },
    {
        id: 3,
        name: 'Infomation',
        links: '/home-one-page/#info'
    },
    {
        id: 4,
        name: 'RoadMap',
        links: '/home-one-page/#roadmap'
    },
    {
        id: 5,
        name: 'Portfolio',
        links: '/home-one-page/#portfolio'
    },
    {
        id: 6,
        name: 'Team',
        links: '/home-one-page/#team'
    },
    {
        id: 7,
        name: 'Technology',
        links: '/home-one-page/#technology'
    },
    {
        id: 8,
        name: 'Testimonial',
        links: '/home-one-page/#testimonial'
    },
    {
        id: 9,
        name: 'Counter',
        links: '/home-one-page/#counter'
    },
    {
        id: 10,
        name: 'Blog',
        links: '/home-one-page/#blog'
    },
    {
        id: 11,
        name: 'FAQ',
        links: '/home-one-page/#faq'
    },
    
]

export default menus;